import { apiRequest, buildUrlWithParams } from "./api-client";

export async function getSupervisorMetrics(ownerId: string, startDate?: string, endDate?: string) {
  return apiRequest<{
    totalSales: number;
    totalTickets: number;
    averageTicket: number;
    salesChange: number;
    ticketsChange: number;
    activeShops: number;
    totalShops: number;
  }>(buildUrlWithParams("/api/supervisor/metrics", { startDate, endDate }));
}

export async function getSupervisorStorePerformance(ownerId: string, startDate?: string, endDate?: string) {
  return apiRequest<{
    stores: Array<{
      id: string;
      name: string;
      managerName: string | null;
      sales: number;
      tickets: number;
      averageTicket: number;
      trend: number;
    }>;
  }>(buildUrlWithParams("/api/supervisor/store-performance", { startDate, endDate }));
}

export async function getSupervisorAlerts() {
  return apiRequest<{
    alerts: Array<{
      type: "critical" | "warning" | "info";
      shopName: string;
      message: string;
    }>;
  }>("/api/supervisor/alerts");
}

export async function getSupervisorDailySales(ownerId: string, startDate?: string, endDate?: string) {
  return apiRequest<{
    dailySales: Array<{
      date: string;
      shopId: string;
      shopName: string;
      sales: number;
      tickets: number;
    }>;
  }>(buildUrlWithParams("/api/supervisor/daily-sales", { startDate, endDate }));
}

export async function getSupervisorTopSellers(ownerId: string, startDate?: string, endDate?: string, limit?: number) {
  return apiRequest<{
    sellers: Array<{
      fullName: string;
      shopName: string;
      totalSales: number;
      tickets: number;
    }>;
  }>(buildUrlWithParams("/api/supervisor/top-sellers", { startDate, endDate, limit }));
}
